import { render, staticRenderFns } from "./AdaDatatable.vue?vue&type=template&id=71179372&scoped=true"
import script from "./AdaDatatable.vue?vue&type=script&lang=js"
export * from "./AdaDatatable.vue?vue&type=script&lang=js"
import style0 from "./AdaDatatable.vue?vue&type=style&index=0&id=71179372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71179372",
  null
  
)

export default component.exports